import { createActions } from "redux-actions";
import { Dispatch } from "redux";
import { NotiModel, RootState } from "../../../models";
import { v4 as uuidv4 } from "uuid";

export const NotificationAcionTypes = createActions({
  ENQUEUE_SNACKBAR: (data) => data,
  REMOVE_SNACKBAR: (data) => data,
});

const enqueueSnackbar = (noti: NotiModel) => (dispatch: Dispatch, getState: () => RootState) => {
  const newNotiId = uuidv4();

  dispatch(
    NotificationAcionTypes.enqueueSnackbar({
      ...getState().notifications,
      list: [
        ...getState().notifications.list,
        {
          id: newNotiId,
          ...noti,
        },
      ],
    })
  );
};

const removeSnackbar = (notiId: string) => (dispatch: Dispatch, getState: () => RootState) => {
  let notis = getState().notifications.list;

  notis = notis.filter((n) => n.id !== notiId);

  dispatch(
    NotificationAcionTypes.removeSnackbar({
      ...getState().notifications,
      list: notis,
    })
  );
};

export const NotificationActions = {
  enqueueSnackbar,
  removeSnackbar,
};
